import { useCallback } from 'react';
import { trackPackageSelect } from '../tracking';
import { selectPackage, selectPlacingType } from '../../../../../../../actions/publishTerms';
import { EPlacingType } from '../../../../../../../types/reducers/publishTerms';
import { loadPublishTerms } from '../../../../../../../thunks/publishTerms/loadPublishTerms';
import { formatPackageOptionLabel } from '../utils';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsChangePackageDisable } from '../../../../../../../selectors/publishTerms';
import { IUsePackagesCheckbox } from './types';
import {
  selectAnalyticsOfferStatus,
  selectAnalyticsProduct,
  selectAnalyticsExtraOfferIds,
} from '../../../../../../../selectors/analytics';
import { TDispatch } from '../../../../../../../../common/types/dispatch';
import { selectPackages } from '../../../../../../../reducers/v2/publicationPackages/selectors';
import { selectActivePlacingType } from '../../../../../../../reducers/v2/paidPublication/selectors';

export const usePackagesCheckbox = (): IUsePackagesCheckbox => {
  const dispatch = useDispatch<TDispatch>();
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const analyticsExtraOfferIds = useSelector(selectAnalyticsExtraOfferIds);
  const packages = useSelector(selectPackages);

  const firstPackage = packages[0];
  const checkboxLabel = formatPackageOptionLabel(firstPackage);

  const isCheckboxDisabled = useSelector(selectIsChangePackageDisable);

  const activePlacingType = useSelector(selectActivePlacingType);

  const isCheckboxChecked = activePlacingType === EPlacingType.package;

  const handleCheckboxChange = useCallback(() => {
    if (isCheckboxDisabled) {
      return;
    }

    if (!isCheckboxChecked) {
      trackPackageSelect({
        analyticsOfferStatus,
        analyticsProduct,
        packageServiceId: firstPackage.serviceId,
        analyticsExtraOfferIds,
      });
      dispatch(selectPackage(firstPackage.id));
    }

    dispatch(selectPlacingType(isCheckboxChecked ? EPlacingType.balance : EPlacingType.package));

    dispatch(loadPublishTerms({ isServicesReload: true }));
  }, [
    analyticsOfferStatus,
    analyticsProduct,
    dispatch,
    firstPackage.id,
    firstPackage.serviceId,
    isCheckboxChecked,
    isCheckboxDisabled,
    analyticsExtraOfferIds,
  ]);

  return {
    label: checkboxLabel,
    checked: isCheckboxChecked,
    disabled: isCheckboxDisabled,
    onChange: handleCheckboxChange,
  };
};
